import { createSelector } from 'reselect';
/* istanbul ignore next */
export const selectMarketplaceReturn = (state) => state.marketplaceReturn || {};
export const selectMarketplaceReturnItems = createSelector(
    selectMarketplaceReturn,
    (marketplaceReturn) => marketplaceReturn.items
);
/* istanbul ignore next */
export const selectMarketplaceReturnItemsFiltered = createSelector(
    selectMarketplaceReturnItems,
    (items) => items.filter((item) => item.isSelected && item.returnQuantity && item.returnReason)
);
/* istanbul ignore next */
export const selectMarketplaceIncidentItemsFiltered = createSelector(
    selectMarketplaceReturnItems,
    (items) =>
        items.filter(
            (item) => item.isSelected && item.returnReason && item.returnReason !== 'select'
        )
);
/* istanbul ignore next */
export const selectMarketplaceReturnTotal = createSelector(
    selectMarketplaceReturnItemsFiltered,
    (items) =>
        items.reduce((total, item) => {
            const selectedAdjustment = item?.maxAllowedAdjustments?.find?.(
                (adjustment) => adjustment.quantity === parseInt(item.returnQuantity, 10)
            );
            const adjustmentAmount = selectedAdjustment?.amount || 0;
            return total + adjustmentAmount;
        }, 0)
);
